import { fetcher } from 'redux/apisThirdParty';
import { ServiceReference, EntityList } from 'types';
import makeGetHook from '@eGroupTeam/hooks/makeGetHook';

const useServiceReferences = makeGetHook<EntityList<ServiceReference>>(
  '/service-references',
  fetcher
);
export default useServiceReferences;
